module.exports = __webpack_public_path__ + "static/img/23.d6aca82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/23.png
// module id = mZ9Z
// module chunks = 0